/// <amd-module name="SuiteCommerce.Blog.PostSearch.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.PostSearch.Configuration", ["require", "exports", "SuiteCommerce.Blog.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PostSearchConfiguration = void 0;
    var PostSearchConfiguration = /** @class */ (function (_super) {
        __extends(PostSearchConfiguration, _super);
        function PostSearchConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(PostSearchConfiguration, "searchLabel", {
            get: function () {
                return this.get('blog.searchLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostSearchConfiguration, "searchHint", {
            get: function () {
                return this.get('blog.searchHint');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostSearchConfiguration, "searchCloseButtonLabel", {
            get: function () {
                return this.get('blog.searchCloseButtonLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostSearchConfiguration, "backToTopLabel", {
            get: function () {
                return this.get('blog.backToTopLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostSearchConfiguration, "searchResultsLabel", {
            get: function () {
                return this.get('blog.searchResultsLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostSearchConfiguration, "noSearchResultsLabel", {
            get: function () {
                return this.get('blog.noSearchResultsLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostSearchConfiguration, "noResultsArticleSuggestionMessage", {
            get: function () {
                return this.get('blog.noResultsArticleSuggestionMessage');
            },
            enumerable: false,
            configurable: true
        });
        return PostSearchConfiguration;
    }(Configuration_1.Configuration));
    exports.PostSearchConfiguration = PostSearchConfiguration;
});
